module.exports = new __parcel__URL__("thorns.09c31415.png").toString();